// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"I4-z","dimensionLabel":"J4-z","styleChooserControlWrapper":"K4-z","styleChooserControl":"L4-z","disabled":"M4-z","giftCard":"N4-z","styleChooserText":"O4-z"};